import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        step: 1,
        loader: false,
    },
    mutations: {
        setLoading(state, data) {
            state.loader = data;
        },
        goNext(state) {
            state.step += 1;
        },
        goBack(state) {
            state.step -= 1;
        },
    },
    actions: {},
    modules: {},
});
